import { allEmploymentIncomeTypeOptions } from './income1003Constants';

export function calculateElapsedYearsMonths(
  dateStr1: string | Date,
  dateStr2: string | Date = new Date(),
) {
  if (dateStr1 === '' || dateStr1 === null) {
    return { years: 0, months: 0 };
  }
  let date1 = new Date(dateStr1);
  let date2 =
    dateStr2 === '' || dateStr2 === null || dateStr2 === '1/1/0001'
      ? new Date()
      : new Date(dateStr2);
  if (date1 > date2) [date1, date2] = [date2, date1];

  let years = date2.getFullYear() - date1.getFullYear();
  let months = date2.getMonth() - date1.getMonth();

  if (months < 0 || (months === 0 && date2.getDate() < date1.getDate())) {
    years--;
    months += 12;
  }

  months = months % 12;

  if (Number.isNaN(months)) months = undefined;
  if (Number.isNaN(years)) years = undefined;

  return { years: years, months: months };
}

export function getIncomeDetailsType(
  value: string,
  returnTypeCode = true,
): string | undefined {
  const option = allEmploymentIncomeTypeOptions.find((type) =>
    returnTypeCode ? type.type === value : type.typeCode === value,
  );
  return returnTypeCode ? option?.typeCode : option?.type;
}
